import React from 'react';
import { connect } from 'react-redux';
import { closeAddActionDialog } from 'store/common/commonActions';
import { addAction } from 'store/reclamation/reclamationsActions';
import { cloturer } from 'store/reclamation/reclamationsActions';

import AddActionDialog from './AddActionDialog';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';


class AddActionDialogContainer extends React.Component {

    constructor(props) {
        super(props);

        // Initialisation du state
        this.state = this.getInitialState();
    }

    getInitialState = () => {
        const initialState = {
            actionData: null,
            sauvegardable: false,
            clotureData: null
        };
        return initialState;
    }

    componentDidMount() {
        this.setState(this.getInitialState());
    }

    handleClickSave = async () => {
        const { addAction, cloturer, reclamationId } = this.props;
        const { actionData, clotureData, warning } = this.state;

        if (warning) {
            this.setState({
                displayWarning: true
            });
        }
        else {
            await addAction(reclamationId, actionData, 0, actionData?.affectationGroupeId ?? 0);
            if (clotureData) {
                await cloturer(reclamationId, clotureData);
            }
        }
    }

    handleClickSaveIgnoreWarning = async () => {
        const { addAction, cloturer, reclamationId } = this.props;
        const { actionData, clotureData } = this.state;

        this.setState({
            warning: '',
            displayWarning: false
        });

        await addAction(reclamationId, actionData, 0, actionData?.affectationGroupeId ?? 0);
        if (clotureData) {
            await cloturer(reclamationId, clotureData);
        }
    }

    handleClickCancel = () => {
        this.props.closeAddActionDialog();
        this.setState(this.getInitialState());
    }

    handleChange = (actionData, clotureData, warning = "") => {
        this.setState({
            actionData: actionData,
            sauvegardable: actionData !== null && (!clotureData || (clotureData.motifResolutionCode !== '' && clotureData.causePrincipaleCode !== '')),
            clotureData: clotureData,
            warning: warning,
            displayWarning: false
        });
    }

    render() {
        const { open, reclamationId, action, isAdding } = this.props;
        const { sauvegardable, warning, displayWarning } = this.state;

        if (!open) return null;

        return (
            <>
                <AddActionDialog
                    open={open}
                    onClickSave={this.handleClickSave}
                    onClickCancel={this.handleClickCancel}
                    onChange={this.handleChange}
                    reclamationId={reclamationId}
                    action={action}
                    sauvegardable={sauvegardable}
                    isAdding={isAdding}
                />

                <Dialog open={!!displayWarning}>

                    <DialogContent>
                        {warning}
                    </DialogContent>

                    <DialogActions>
                        <Button
                            onClick={this.handleClickSaveIgnoreWarning}
                            variant="contained"
                            color="secondary"
                        >
                            OK
                        </Button>
                    </DialogActions>

                </Dialog>
            </>
        );
    }
}

const mapStateToProps = state => ({
    open: state.common.addActionDialogOpen,
    reclamationId: state.common.addActionData.reclamationId,
    action: state.common.addActionData.action,
    isAdding: state.common.addActionData.isAdding
});

const mapDispatchToProps = dispatch => ({
    addAction: (reclamationId, actionData, actionId, affectationGroupeId) => dispatch(addAction(reclamationId, actionData, actionId, affectationGroupeId)),
    cloturer: (reclamationId, clotureData) => dispatch(cloturer(reclamationId, clotureData)),
    closeAddActionDialog: () => dispatch(closeAddActionDialog())
});

export default connect(mapStateToProps, mapDispatchToProps)(AddActionDialogContainer);